import { render, staticRenderFns } from "./TaxForm.vue?vue&type=template&id=54371ae9"
import script from "./TaxForm.vue?vue&type=script&lang=js"
export * from "./TaxForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports